import { gql } from "@apollo/client";

export const getStringQueryCombosRI = (fieldsCombo) => {
  let query = '';
  fieldsCombo.map(({ name, comboName }) => {
    query += `
        ${name}: comboRI(campo: "${comboName}") {
            comboRIValor{
                valor
                idComboRIValor
            }
        }
        `;
  });
  return gql`
    query {
        ${query}
    }`;
};